const env = {
  API_URL: process.env.REACT_APP_BASE_URL,
};

export default env;
